import React from "react";
import DefaultLayout from "../../components/layout/DefaultLayout";
import {ValidatorForm} from "react-material-ui-form-validator";
import {useDispatch, useSelector} from "react-redux";
import SubTitle from "../../components/layout/typography/SubTitle";
import FormBlocContainer from "../../components/layout/form/FormBlocContainer";
import TextInput from "../../components/layout/form/inputs/text/TextInput";
import EmailInput from "../../components/layout/form/inputs/text/EmailInput";
import SelectInput from "../../components/layout/form/inputs/select/SelectInput";
import SendIcon from "@mui/icons-material/Send";
import {Button, TextareaAutosize} from "@mui/material";
import Rules from "../../config/rules";
import TextAreaInput from "../../components/layout/form/inputs/textarea/TextAreaInput";
import Grid from "@mui/material/Grid";

const ContactPage = () => {
    const mainForm = React.createRef()
    const dispatch = useDispatch();
    const account = useSelector(state => state.account)
    const { selectedPerimeter } = useSelector(state => state.extranet)


    const [state, setState] = React.useState({
        contact: '',
        subjects: [],
        chosenSubject: '',
        message: ''
    });


    React.useLayoutEffect(() => {

        if (account.user) {
            let extraState = {
                firstname: account.profil.firstname,
                lastname: account.profil.lastname,
                email: account.user.email,
            }
            if (account.user.type === "ENTREPRISE" ) {
                extraState = {
                    ...extraState,
                    raisonSociale: selectedPerimeter.raisonSociale,
                    subjects: [
                        {label: 'Service prestations', value: '_ENTREPRISE_PRESTATIONS'},
                        {label: 'Incohérence des données', value: '_ENTREPRISE_INCOHERENCE_DATA'},
                        {label: 'Problème d\'affichage', value: '_ENTREPRISE_PB_DISPLAY'},
                        {label: 'Problème de regroupement d\'entreprise', value: '_ENTREPRISE_REGROUPEMENT'},
                        {label: 'Service affiliations', value: '_ENTREPRISE_PARAMETRAGE'},
                        {label: 'Autres', value: '_ENTREPRISE_AUTRES'},
                    ]
                }
            } else {
                extraState = {
                    ...extraState,
                    subjects: [
                        {label: 'Problème de prestations', value: '_ASSURE_PRESTATIONS'},
                        {label: 'Problème de connexion', value: '_ASSURE_CONNEXION'},
                        {label: 'Incohérence des données', value: '_ASSURE_INCOHERENCE_DATA'},
                        {label: 'Problème d\'affichage', value: '_ASSURE_PB_DISPLAY'},
                        {label: 'Autres', value: '_ASSURE_AUTRES'},
                    ]
                }
            }
            setState(prevState => ({
                ...prevState,
                ...extraState
            }));
        }

    }, [account.user]);

    const handleChange = (event) => {
        setState(prevState => ({
            ...prevState,
            [event.target.name]: event.target.value
        }))
    }

    if (account.user) {
        return <DefaultLayout>
            <ValidatorForm
                ref={mainForm}
                onSubmit={() => console.log("submit")}
            >
                <SubTitle label={"Formulaire de contact"} />
                <FormBlocContainer title="Demande">
                    <TextInput
                        sm={12}
                        label={account.user.type === "ENTREPRISE" ? "Prénom représentant" : "Prénom assuré"}
                        name={"firstname"}
                        value={state.firstname}
                        handleChange={handleChange}
                        validators={['required']}
                        errorMessages={[Rules.txtRequis]}
                    />
                    <TextInput
                        sm={12}
                        label={account.user.type === "ENTREPRISE" ? "Nom représentant" : "Nom assuré"}
                        name={"lastname"}
                        value={state.lastname}
                        handleChange={handleChange}
                        validators={['required']}
                        errorMessages={[Rules.txtRequis]}
                    />
                    <EmailInput
                        sm={12}
                        label={account.user.type === "ENTREPRISE" ? "Email représentant" : "Email assuré"}
                        name={"email"}
                        value={state.email}
                        handleChange={handleChange}
                        validators={['required']}
                        errorMessages={[Rules.txtRequis]}
                    />

                    {
                        account.user.type === "ENTREPRISE" && <TextInput
                            sm={12}
                            label={"Raison sociale"}
                            name={"raisonSociale"}
                            value={state.raisonSociale}
                            handleChange={handleChange}
                            validators={['required']}
                            errorMessages={[Rules.txtRequis]}
                        />
                    }

                    <TextInput
                        sm={12}
                        label={"Contact"}
                        name={"contact"}
                        value={state.contact}
                        handleChange={handleChange}
                        validators={['required']}
                        errorMessages={[Rules.txtRequis]}
                    />

                    <SelectInput
                        id="chosenSubject"
                        name="chosenSubject"
                        label="Sujet"
                        validators={['required']}
                        errorMessages={[Rules.txtRequis]}
                        value={state.chosenSubject ?? " "}
                        onChange={handleChange}
                        sm={12}
                        xs={12}
                        items={state.subjects}
                        className={"select select-subject"}
                        displayEmpty
                    />

                    <TextAreaInput
                        sm={12}
                        label={"Votre message"}
                        name={"message"}
                        value={state.message}
                        validators={['required']}
                        errorMessages={[Rules.txtRequis]}
                        minRows={10}
                        handleChange={handleChange}
                        variant={"outlined"}
                        multiline
                    />

                </FormBlocContainer>

                <Grid xs={6} item className={"right"}>
                    <Button
                        variant={"outlined"}
                        className={"center-right mobileButton"}
                        style={{ width: '100%' }}
                        type={"submit"}
                    >
                        Envoyer le message
                        <SendIcon />
                    </Button>
                </Grid>

                <br/>
                <br/>
                <br/>
            </ValidatorForm>
        </DefaultLayout>
    }
}

export default ContactPage
